import '../EngagementLogs/EngagementLogs.css';
import '../../globalcss.css';

import { Drawer, Spin } from 'antd';
import { Box } from 'grommet';
import MaterialTable, { MTableCell } from 'material-table';
import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';

import EngagementDetailDrawer from '../EngagementDetailDrawer/EngagementDetailDrawer';
import {
  BackIcon,
  CakeIcon,
  DRAWER_STYLE,
  HEADER_STYLE,
  TitleMain,
  TitleSubtitle,
  TitleWrapper,
} from './MemberMessagesDrawer.styled';

const getMemberLabel = memberInfo => {
  if (!memberInfo?.isMember) return 'Non-member';
  const id = memberInfo.source?.memberId;
  return id ? `Member #${id}` : 'Member';
};

const DrawerTitle = ({ memberInfo, messageCount, loading }) => {
  if (loading) return 'Loading Contact Messages';

  const name = memberInfo
    ? `${memberInfo.firstName ?? ''} ${memberInfo.lastName ?? ''}`.trim()
    : '';
  const subtitleParts = [
    getMemberLabel(memberInfo),
    `${messageCount} messages`,
  ].filter(Boolean);

  return (
    <TitleWrapper>
      <TitleMain>
        Messages sent to
        {name && (
          <>
            {' '}
            <strong>{name}</strong>
          </>
        )}
      </TitleMain>
      {subtitleParts.length > 0 && (
        <TitleSubtitle>{subtitleParts.join(' · ')}</TitleSubtitle>
      )}
    </TitleWrapper>
  );
};

// eslint-disable-next-line react/display-name
const renderDateCell = rowData => <p>{rowData.date}</p>;

// eslint-disable-next-line react/display-name
const renderSubjectCell = rowData => <p>{rowData.messageSubject}</p>;

// eslint-disable-next-line react/display-name
const renderCakeCell = rowData =>
  rowData.isAC ? (
    <Tooltip
      title="Automated Campaign Message"
      placement="top"
      style={{ justifyContent: 'center' }}
    >
      <CakeIcon />
    </Tooltip>
  ) : null;

const messageColumns = [
  {
    title: 'Date/Time ',
    field: 'date',
    defaultSort: 'desc',
    render: renderDateCell,
  },
  {
    title: '',
    field: 'cake',
    render: renderCakeCell,
  },
  {
    title: 'Subject',
    field: 'messageSubject',
    render: renderSubjectCell,
  },
];

// eslint-disable-next-line react/display-name
const tableCell = props => <MTableCell {...props} />;

const MemberMessagesDrawer = props => {
  const [pageSize, setPageSize] = useState(50);
  const {
    msgsLoading,
    memberInfo,
    setVisible,
    visible,
    messages,
    showdetailsDrawer,
    setDetailsDrawerVisible,
    detailsDrawerVisible,
    memberMessageInfo,
    msgDetailsLoading,
    memberEngagement,
  } = props;

  const onClose = () => setVisible(false);

  const handlePageSizeChange = newSize => {
    localStorage.setItem('pageSize', newSize);
    setPageSize(newSize);
  };

  return (
    <Drawer
      title={
        <DrawerTitle
          memberInfo={memberInfo}
          messageCount={messages?.length ?? 0}
          loading={msgsLoading}
        />
      }
      headerStyle={HEADER_STYLE}
      closeIcon={<BackIcon />}
      width={800}
      zIndex={1500}
      onClose={onClose}
      visible={visible}
      style={DRAWER_STYLE}
    >
      <div className="ManagePortalUserscomp ant-drawerpart">
        <Box overflow="auto">
          <div className="middlePart">
            <Box className="noterouter_managetable btnseparation">
              <Spin
                spinning={msgsLoading}
                tip="Loading Message Sent to User..."
              >
                <MaterialTable
                  components={{ Cell: tableCell }}
                  columns={messageColumns}
                  data={messages}
                  className="Manage_materialtable"
                  title=""
                  actions={[]}
                  options={{
                    search: true,
                    sorting: true,
                    pageSize: pageSize,
                    pageSizeOptions: [10, 20, 50],
                  }}
                  onChangeRowsPerPage={handlePageSizeChange}
                  onRowClick={(e, data) => showdetailsDrawer(data)}
                />
              </Spin>
              <EngagementDetailDrawer
                setDetailsDrawerVisible={setDetailsDrawerVisible}
                detailsDrawerVisible={detailsDrawerVisible}
                memberMessageInfo={memberMessageInfo}
                memberInfo={memberInfo}
                msgDetailsLoading={msgDetailsLoading}
                memberEngagement={memberEngagement}
              />
            </Box>
          </div>
        </Box>
      </div>
    </Drawer>
  );
};

export default MemberMessagesDrawer;
